<template>
    <section class="contact-section" id="contact">
      <h2 class="contact-title">Contact Us</h2>
      <p class="contact-description">
        You can contact us directly via email or reach us through social platforms.
      </p>
  
      <div class="contact-links">
        <div class="contact-line">
          <span class="label">Email:</span>
          <a href="mailto:support@streamboxtv.live">support@streamboxtv.live</a>
        </div>
       
      </div>
    </section>
  </template>
  
  <style scoped>
  .contact-section {
    padding: 60px 20px;
    background-color: #0a0a0a;
    color: #fff;
    text-align: center;
  }
  
  .contact-title {
    font-size: 2.4rem;
    margin-bottom: 10px;
    font-weight: 600;
  }
  
  .contact-description {
    font-size: 1.1rem;
    color: #bbb;
    margin-bottom: 40px;
  }
  
  .contact-links {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 600px;
    margin: 0 auto;
  }
  
  .contact-line {
    display: flex;
    justify-content: center;
    gap: 10px;
    font-size: 1.1rem;
  }
  
  .contact-line .label {
    font-weight: 500;
    color: #888;
  }
  
  .contact-line a {
    color: #00ccff;
    text-decoration: none;
  }
  
  .contact-line a:hover {
    text-decoration: underline;
  }
  </style>
  